import React from "react";

export default function ProfileSwitchLoader({
  open = false,
  text = "Loading...",
}) {
  if (!open) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-white/70 tw-backdrop-blur-md tw-transition-all tw-duration-300">
      <div className="tw-w-12 tw-h-12 tw-border-4 tw-border-primary-500 tw-border-t-gray-300 tw-border-solid tw-rounded-full tw-animate-spin" />
      <p className="tw-mt-5 tw-text-gray-700 tw-text-sm tw-font-medium tw-tracking-wide">
        {text}
      </p>
    </div>
  );
}
